












import { Component, Prop, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'

@Component
export default class ExternalPipelineIcon extends Vue {
    @Prop({ required: true }) readonly pipeline!: Pipeline
}
